import React from "react";
import styled from "styled-components";

import Box from "@mui/material/Box";
import Button from "src/components/core/Button";
import SectionRearrangeDialog from "./SectionRearrangeDialog";

import ImportExportIcon from "@mui/icons-material/ImportExport";

import { hexToRgba } from "src/common/color";
import { Black, White } from "src/styles/color";

import { useDialog } from "src/context/DialogContext";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

const Section = () => {
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  return (
    <S.BoxWrapper>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Landing Page
        <Button
          variant="contained"
          size="large"
          sx={{
            width: "100%",
            minWidth: 148,
            maxWidth: 350,
          }}
          onClick={() =>
            openDialog({
              type: "custom",
              customDialog: (
                <SectionRearrangeDialog
                  onClose={() => closeDialog()}
                  onSuccess={() => {
                    closeAllDialogs();
                  }}
                />
              ),
            })
          }
          startIcon={<ImportExportIcon />}
        >
          สลับตำแหน่ง
        </Button>
      </Box>
    </S.BoxWrapper>
  );
};

export default Section;
